"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

// Lazy load analytics components to avoid blocking initial page load
const GoogleAnalytics = dynamic(() => import("@/components/google-analytics"), {
  ssr: false,
});

const SpeedInsights = dynamic(
  () => import("@vercel/speed-insights/next").then((mod) => mod.SpeedInsights),
  { ssr: false }
);

const Analytics = dynamic(
  () => import("@vercel/analytics/react").then((mod) => mod.Analytics),
  { ssr: false }
);

const PerformanceMonitor = dynamic(
  () => import("@/components/performance-monitor"),
  {
    ssr: false,
  }
);

export default function ClientOnlyAnalytics() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Defer analytics loading to improve initial page performance
    const timer = setTimeout(() => {
      setShouldLoad(true);
    }, 2000); // Load analytics 2 seconds after page mount

    // Load immediately if page becomes hidden (user is leaving)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        setShouldLoad(true);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  if (!shouldLoad) {
    return null;
  }

  return (
    <>
      <SpeedInsights debug={false} />
      <Analytics debug={false} />
      {process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID && (
        <GoogleAnalytics
          GA_MEASUREMENT_ID={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID}
        />
      )}
      <PerformanceMonitor />
    </>
  );
}
